import { AHText, Box, useScaleFactor } from "arkh";
import { FormattedMessage } from "react-intl";
import { Logo } from "../../OS/Logo";
import { Image } from "react-native";

export const NoName = () => {
  const sf = useScaleFactor();

  return (
    <Box
      spaceTop="xxlarge"
      style={{
        backgroundColor: "#F4F3F9",
        height: "100%",
        alignItems: "center",
      }}
    >
      <Logo color="surface-cta" width={sf * 110} style={{ flexShrink: 0 }} />
      <AHText
        spaceTop="large"
        style={{
          fontFamily: "poppins-display",
          fontWeight: "800",
        }}
        type="title-big"
      >
        <FormattedMessage
          description="Login name splash screen title"
          defaultMessage="Give me a name!"
        />
      </AHText>
      <AHText
        spaceTop="medium"
        type="list-item-title"
        color="text-secondary"
        style={{
          textAlign: "center",
          width: "50%",
        }}
      >
        <FormattedMessage
          description="Login name splash screen subtitle"
          defaultMessage="Choose a name for this screen."
        />
      </AHText>
      <Box
        style={{
          flex: 1,
          width: "100%",
          paddingTop: 80 * sf,
          paddingBottom: 80 * sf,
          alignItems: "center",
        }}
      >
        <Image
          style={{ maxHeight: "100%", maxWidth: "100%", resizeMode: "contain" }}
          source={require("../../assets/images/name.png")}
        />
      </Box>
    </Box>
  );
};
